module.exports = __webpack_public_path__ + "img/py.2bc8f169.svg";